import { render } from "./IngresoComponent.vue?vue&type=template&id=3106482e"
import script from "./IngresoComponent.vue?vue&type=script&lang=js"
export * from "./IngresoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__